/**
 * Vehicle trade data wizard panel
 *
 * @author Fabio Dal Santo <fabio@gestionaleauto.com>
 */
import React from 'react';

/**
 * Redux
 */
import { useSelector } from 'react-redux';
import { wizardState } from '../../redux/wizardSlice';
import { leadState } from '../../redux/leadSlice';

/**
 * Components
 */
import MakeModel from './tradeIn/MakeModel';
import Tech from './tradeIn/Tech';
import Resume from './tradeIn/Resume';
import Data from './tradeIn/Data';

/**
 * @returns {JSX.Element}
 */
function TradeInWizard() {
  const { subStep: currentStep } = useSelector(wizardState);
  const { quoteSteps: steps } = useSelector(leadState);

  return (
    <div className="col-xs-12">
      <div
        id={`ga-ecommerce-quote-${steps[currentStep].id}`}
        className={`ga-ecommerce-quote-${steps[currentStep].id}`}
      >
        { currentStep === 0 && <MakeModel /> }
        { currentStep === 1 && <Tech /> }
        { currentStep === 2 && <Data />}
        { currentStep === 3 && <Resume /> }
      </div>
    </div>
  );
}

export default TradeInWizard;
